// tslint:disable
import { BaseAvroRecord } from "../../BaseAvroRecord";
import { Origin } from "./OriginEnum";

export interface TraceContext {
    traceId: string;
    pageTraceId: string;
    spanId: string;
    parentId: string;
}

export interface Meta {
    uuid: string;
    emitted: number;
    origin: Origin;
    trace?: null | TraceContext;
}

export interface FailedRecordInterface {
    meta: Meta;
    payload: string;
    topic: string;
    details: string;
}

export class FailedRecord extends BaseAvroRecord implements FailedRecordInterface {

    public meta!: Meta;
    public payload!: string;
    public topic!: string;
    public details: string = "";

    public static readonly subject: string = "failed-record";
    public static readonly schema: object = {
    "type": "record",
    "name": "FailedRecord",
    "namespace": "storyblocks.common",
    "fields": [
        {
            "name": "meta",
            "type": {
                "type": "record",
                "name": "Meta",
                "fields": [
                    {
                        "name": "uuid",
                        "type": "string"
                    },
                    {
                        "name": "emitted",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "origin",
                        "type": {
                            "type": "enum",
                            "name": "Origin",
                            "symbols": [
                                "VIDEOBLOCKS",
                                "AUDIOBLOCKS",
                                "GRAPHICSTOCK",
                                "STORYBLOCKS",
                                "STORYBLOCKS_NEXTJS",
                                "CONTRIBUTOR_PORTAL",
                                "TEMPLATE_EDITOR",
                                "ACCOUNT_SERVICE",
                                "BILLING_SERVICE",
                                "CONTENT_SERVICE",
                                "PAYOUT_SERVICE",
                                "TRANSLATION_SERVICE",
                                "CONTENT_RATING_APP",
                                "FEATURE_FLAG_SERVICE",
                                "PREMIERE_PRO_PLUGIN",
                                "AFTER_EFFECTS_PLUGIN",
                                "EXAMPLE_SERVICE",
                                "SEARCH_SERVICE",
                                "CONTENT_JOB",
                                "DATA_JOB",
                                "MISC",
                                "STORYBOARD",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "trace",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "TraceContext",
                                "fields": [
                                    {
                                        "name": "traceId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "pageTraceId",
                                        "type": "string",
                                        "default": ""
                                    },
                                    {
                                        "name": "spanId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "parentId",
                                        "type": "string",
                                        "default": ""
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "payload",
            "type": "string"
        },
        {
            "name": "topic",
            "type": "string"
        },
        {
            "name": "details",
            "type": "string",
            "default": ""
        }
    ]
}

    public schema(): object {
        return FailedRecord.schema;
    }

    public subject(): string {
        return FailedRecord.subject;
    }
}
